import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatService } from '../../service/chat-service'
import { ToastrService } from 'ngx-toastr';
import { InteractionService } from '../../service/interaction/interaction.service';
import { PlatformRegionService } from '../../service/shared/platform-region.service';
@Component({
    selector: 'app-add-questiont',
    templateUrl: './add-questiont.component.html',
    styleUrl: './add-questiont.component.scss',
    standalone: false
})
export class AddQuestiontComponent {
  faqQuestion: string = '';
  businessUnitCode = sessionStorage.getItem("businessUnitCode");
  userId = Number(sessionStorage.getItem("userId"));
  isEditMode: boolean;
  constructor(private readonly route: ActivatedRoute, private readonly dialog: MatDialog, public ChatService: ChatService,
    public toaster: ToastrService, public router: Router, private readonly intService: InteractionService,
    public dialogRef: MatDialogRef<AddQuestiontComponent>,private PlatformRegionService:PlatformRegionService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.faqQuestion = data?.faq || '';
    this.isEditMode = !!data?.faq;
  }
  cancel() {
    this.dialog.closeAll();
  }
  submit() {
    if (this.isEditMode) {
      this.onEditClick();
    } else {
      this.addQuestion()
    }
    this.dialogRef.close({ faq: this.faqQuestion, isEdit: this.isEditMode });
  }
  onEditClick() {
     if (!this.faqQuestion || this.faqQuestion.trim() === '') {
      this.toaster.info('Please enter a question before submitting.', '', { positionClass: 'toast-top-right' });
      return;
    }
    const request = {
      "faq": this.faqQuestion,
      "business_unit": this.businessUnitCode,
      "updated_by": Number(sessionStorage.getItem('userId'))

    };
    const faqId = Number(this.data.id);

    this.ChatService.editQuestion(faqId, request).subscribe(
      response => {
        this.intService.triggerRefresh();
        this.toaster.success('Question updated successfully', '', { positionClass: 'toast-top-right' });
      },
      error => {
        this.toaster.error('Failed to update question', '', { positionClass: 'toast-top-right' });
      }
    );
  }

  addQuestion() {
    if (!this.faqQuestion || this.faqQuestion.trim() === '') {
      this.toaster.info('Please enter a question before submitting.', '', { positionClass: 'toast-top-right' });
      return;
    }
    const request = {
      "faq": this.faqQuestion,
      "business_unit": this.businessUnitCode,
      "created_by": this.userId,
      "region_name": this.PlatformRegionService.selectedRegion.name || ''
    };

    this.ChatService.createFAaq(request).subscribe(
      res => {
        this.toaster.success('Question added successfully', '', { positionClass: 'toast-top-right' });
        this.intService.triggerRefresh();
      },
      error => {
        this.toaster.error('Failed to add question', '', { positionClass: 'toast-top-right' });
      }
    );
  }

}
